export default __webpack_public_path__ + "static/media/ExchangeLogo.511a0cca.webp";